"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubformDuplicateTool = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var image_button_1 = require("../../../components/button/image.button");
var icons_1 = require("../../../components/icon/icons");
var notification_service_1 = require("../../../components/notification.toast/notification.service");
var i18n_1 = require("../../../i18n");
var services_1 = require("../../../services");
var SubformDuplicateTool = /** @class */ (function () {
    function SubformDuplicateTool() {
    }
    SubformDuplicateTool.view = function (collection) {
        var isMeasurementCopy = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_SUBFORM_MEASUREMENT_COPY)
            || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.COPY_SUBFORM, {
            title: isMeasurementCopy ? i18n_1.T.COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS : i18n_1.T.COLLECTION_EDIT_COPY_SUBFORM,
            titleAttrs: { title: collection.schema.displayName },
            onclick: function (e) {
                e.stopPropagation();
                SubformDuplicateTool.duplicateSubFormInstance(collection);
            }
        });
    };
    SubformDuplicateTool.duplicateSubFormInstance = function (instance) {
        var isMeasurementCopy = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_SUBFORM_MEASUREMENT_COPY)
            || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        var newInstance = instance.parent.Mutator.copyInstance(instance.parent, instance.instanceId);
        // Remove all "measurements"
        newInstance.forEachField(function (field) {
            if (core_shared_1.CollectionModelFieldHeight.isHeightField(field) && !isMeasurementCopy) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldNumber.isNumberField(field) && !field.isManual()) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldImage.isImageField(field)) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldLocation.isLocationField(field)) {
                field.Mutator.clear();
            }
        });
        notification_service_1.NotificationService.success({ key: i18n_1.T.COLLECTION_EDIT_COPY_SUBFORM_SUCCESS, attrs: { title: instance.title } });
        var label = isMeasurementCopy ? 'subform:duplicate:measurementCopy' : 'subform:duplicate';
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, label, instance.instanceId);
    };
    tslib_1.__decorate([
        mobx_1.action
    ], SubformDuplicateTool, "duplicateSubFormInstance", null);
    return SubformDuplicateTool;
}());
exports.SubformDuplicateTool = SubformDuplicateTool;
//# sourceMappingURL=subform.duplicate.tool.js.map